import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { apiClient } from "../utils/apiClient";

import "../styles/app.scss";
import SlaContent from "../components/sla/sla-content.component";
import {useLocation} from "@reach/router";
import {triggerTealiumEvent} from "../utils/tealiumUtils";

export default function OurLatestServiceLevels() {
  const [content, setContent] = useState(null);
  const [headline, setHeadline] = useState(null);
  const [publishedAt, setPublishedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  if (typeof window !== "undefined" && window.utag) {
    triggerTealiumEvent({
      tealiumEvent: "view",
      pageUrl: location.href,
      pageName: "our latest service levels",
      pageType: "product information",
      pageSubCategory: "our latest service levels",
      pageCategory: location,
      rawDataLayer: "10451v68",
    });
  }

  useEffect(() => {
    const loadSla = async () => {
      try {
        const response = await apiClient.get("sla/current");

        const topLevel = typeof response.data === "string" ? JSON.parse(response.data) : response.data;
        const parsedContent = topLevel.content === undefined ? topLevel : topLevel.content;

        setContent(parsedContent);
        setHeadline(response.title)
        setPublishedAt(response.publishedAt);
      } catch (err) {
        console.error("Failed to fetch SLA:", err);
        setError("Could not load service levels.");
      } finally {
        setLoading(false);
      }
    };

    loadSla();
  }, []);

  return (
    <Layout
      title="Our latest service levels"
      metaDescription="We have recently been experiencing high volumes of applications and amendments, which is impacting our service levels. We are doing everything we can to improve our current position."
    >
      {loading && <section className="page-section"><p>Loading...</p></section>}
      {error && <section className="page-section"><p style={{ color: "red" }}>{error}</p></section>}
      {content && <SlaContent headline={headline} content={content} />}
    </Layout>
  );
}
